var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.483 0.600098H14.408C15.533 0.600098 16.1 1.1311 16.1 2.2111V9.7891C16.1 10.8601 15.533 11.4001 14.408 11.4001H2.483C1.358 11.4001 0.791 10.8601 0.791 9.7891V2.2111C0.791 1.1311 1.358 0.600098 2.483 0.600098ZM8.441 8.3401L14.507 3.3631C14.723 3.1831 14.894 2.7691 14.624 2.4001C14.363 2.0311 13.886 2.0221 13.571 2.2471L8.441 5.7211L3.32 2.2471C3.005 2.0221 2.528 2.0311 2.267 2.4001C1.997 2.7691 2.168 3.1831 2.384 3.3631L8.441 8.3401Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.66645aac30db22e7a62301c06b93f541.svg";
export { ForwardRef as ReactComponent };